// extracted by mini-css-extract-plugin
export var errorsContainer = "_t5-1";
export var link = "_t5-0";